<template>
    <div style="height:800px; overflow:hidden;">
        <div id="scheduler_here" class="dhx_cal_container" style='width:100%; height:100%; top:100px'>
            <div class="dhx_cal_navline">
                <div class="dhx_cal_prev_button">&nbsp;</div>
                <div class="dhx_cal_next_button">&nbsp;</div>
                <div class="dhx_cal_today_button"></div>
                <div class="dhx_cal_date"></div>
                <div class="dhx_cal_tab" name="day_tab" style="right:204px;"></div>
                <div class="dhx_cal_tab" name="week_tab" style="right:140px;"></div>
                <div class="dhx_cal_tab" name="month_tab" style="right:76px;"></div>
            </div>
            <div class="dhx_cal_header">
            </div>
            <div class="dhx_cal_data">
            </div>
        </div>
    </div>
</template>
<script>
    import GlobalMixin from '@/GlobalMixin.js'
    export default {
        mixins: [GlobalMixin],
        components: {  },
        data() {
            return {
                date_of_birthError: '',
            }
        },
        methods: {
            init() {
        scheduler.config.multi_day = true;
        scheduler.config.details_on_dblclick = true;
        scheduler.config.details_on_create = true;

        scheduler.config.full_day = true; // enable parameter to get full day event option on the lightbox form

        scheduler.init('scheduler_here', new Date(2018, 5, 11), "week");
        //scheduler.load("/assets/js/events.json", function () {
        //    //scheduler.showLightbox("1261150564");          
        //});
                scheduler.attachEvent("onEventSave", function (id, ev, is_new) {
                    if (!ev.text) {
                        alert("Text must not be empty");
                        return false;
                    }
                    if (!ev.text.length < 20) {
                        alert("Text too small");
                        return false;
                    }
                    return true;
                })
    },
            AfterMountedFn() {
                let self = this;
                self.$loadScript("/assets/js/dhtmlxscheduler.js?v=5.3.13")
                    .then(() => {
                        self.init();
                        scheduler.parse([
                            { text: "Meeting", start_date: "2021-11-11 14:00", end_date: "2021-11-11 17:00" },
                            { text: "Conference", start_date: "2021-11-15 12:00", end_date: "2021-11-18 19:00" },
                            { text: "Interview", start_date: "2021-11-24 09:00", end_date: "2021-11-24 10:00" }
                        ], "json");
                    })
                    .catch(() => {
                    });
            },
        }
    }
    
</script>
<style>
    @import '/assets/css/dhtmlxscheduler_material.css?v=5.3.13';
</style>